import {
  BottomSheet,
  BottomSheetIllustrationContent,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { DialogContent } from "@mui/material";
import { generatePath, useHistory } from "react-router-dom";

import { Button } from "../../components/Button";
import { DialogFooter } from "../../components/DialogFooter";

interface AddLicenseInReviewBottomSheetProps {
  modalState: UseModalState;
  roleDetailsPath: string;
  qualificationId: string;
}

export function AddLicenseInReviewBottomSheet(props: AddLicenseInReviewBottomSheetProps) {
  const { modalState, roleDetailsPath, qualificationId } = props;
  const history = useHistory();

  // We need to override the closeModal function to call the onSubmittedCtaClick function,
  // because we direct to a different page (backdrop page) when the user clicks the button.
  modalState.closeModal = () => {
    history.replace(generatePath(roleDetailsPath, { qualificationId }));
    modalState.setModalStatus("closed");
  };

  return (
    <BottomSheet
      canDismiss
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical">
          <Button
            fullWidth
            size="large"
            variant="contained"
            onClick={() => {
              history.replace(generatePath(roleDetailsPath, { qualificationId }));
            }}
          >
            Got it
          </Button>
        </DialogFooter>
      }
      onClose={() => {
        history.replace(generatePath(roleDetailsPath, { qualificationId }));
      }}
    >
      <DialogContent sx={{ paddingX: 5 }}>
        <BottomSheetIllustrationContent
          illustrationType="document-review"
          title="License In Review"
          description="Our team will review your submission and get back to you within 4 hours"
        />
      </DialogContent>
    </BottomSheet>
  );
}
